import Phaser from 'phaser';
import Boot from './view/boot.js';
import Preload from './view/preload.js';
import Popup from './view/popup.js';
import Menu from './view/menu.js';
import Form from './view/questionnare/form.js';
import Intro from './view/questionnare/intro.js';
import Outro from './view/questionnare/outro.js';
import Sus from './view/questionnare/sus.js';
import Rules from './view/rules.js';
import Main_Storyboard from './view/main-storyboard.js';
import Main_Questions from './view/main-questions.js';
import UIScene from './view/UIScene.js';
import Story_select from './view/story-select.js';
import Storyboard_1 from './view/stories/story-1/storyboard-1.js';
import Storyboard_2 from './view/stories/story-2/storyboard-2.js';
import Storyboard_3 from './view/stories/story-3/storyboard-3.js';
import Storyboard_4 from './view/stories/story-4/storyboard-4.js';
import Storyboard_5 from './view/stories/story-5/storyboard-5.js';
import Storyboard_6 from './view/stories/story-6/storyboard-6.js';
import Storyboard_7 from './view/stories/story-7/storyboard-7.js';
import PairsMinigame from './view/stories/story-1/pairs.js';
import Pairs2Minigame from './view/stories/story-2/pairs2.js';
import TicTacToeGame from './view/stories/story-5/tic-tac-toe.js';
import SimonSays from './view/stories/story-5/simon-says.js';
import BricksMinigame from './view/stories/story-7/bricks.js';
import EndScreen from './view/endscreen.js';
import End from './view/end.js';
import Credits from './view/credits.js';

const config = {
	type: Phaser.CANVAS,
	width: 1499,
	height: 800,
	scene: [
		Boot,
		Preload,
		Popup,
		Menu,
		Form,
		Intro,
		Rules,
		Main_Storyboard,
		Main_Questions,
		UIScene,
		Story_select,
		Storyboard_1,
		Storyboard_2,
		Storyboard_3,
		Storyboard_4,
		Storyboard_5,
		Storyboard_6,
		Storyboard_7,
		PairsMinigame,
		Pairs2Minigame,
		BricksMinigame,
		TicTacToeGame,
		SimonSays,
		Outro,
		Sus,
		EndScreen,
		End,
		Credits,
	],
	scale: {
		mode: Phaser.Scale.FIT,
		autoCenter: Phaser.Scale.CENTER_BOTH,
		window: Phaser.Scale.LANDSCAPE,
	},
	parent: 'divId',
	physics: {
		default: 'arcade',
	},
	dom: {
		createContainer: !0,
	},
};

export default new Phaser.Game(config);
